import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { api } from "services/api.service";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async ({ params }: LoaderFunctionArgs) => {
  try {
    const { data: inventory } = await api.get(`/inventories/${params.inventoryId}`);
    return { inventory };
  } catch (e) {
    return redirect(`/pickups/${params.pickupId}/add-photos/scan`);
  }
});
